import { useMutation } from "@tanstack/react-query";
import {
  ChangeAvatarRequest,
  PatientControllerApi,
} from "../../../../../services";
import { getConfigObject } from "../../../../../utils/utils";

type Param = {
  changeAvatarRequest: ChangeAvatarRequest;
  xTENANTID?: string;
};

/**
 *
 * @author Rajkumar Rathod
 */
export const useChangePatientAvatar = () => {
  return useMutation({
    mutationFn: async (param: Param) =>
      new PatientControllerApi(getConfigObject()).changeAvatar2(
        param.changeAvatarRequest,
        param.xTENANTID
      ),
  });
};
